import React from "react";
import { render } from "react-dom";
import ShareLink from "../widgets/share_link";

const shareLinks = document.querySelectorAll(".share-link");
if (shareLinks.length) shareLinks.forEach(elem => render(<ShareLink elem={elem} />, elem));